// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ef0ebf4c","239":"ccec48d1","455":"a65dfef7"}[chunkId] + ".chunk.js";
};